/* eslint-disable camelcase */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { ptBR } from '@mui/material/locale';
import {
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  Tooltip,
  Button,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from 'react-router-dom';
import { get } from 'lodash';
import {
  FaEdit,
  FaWindowClose,
  FaExclamation,
  FaClipboardList,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { ContainerGrid, Title } from '../../styles/GlobalStyles';
import axios from '../../services/axios';
import Loading from '../../components/Loading';
import * as colors from '../../config/colors';

const textData = 'Tipo de Despesas';
const tableRoute = 'tipodespesa';
const tableDatas = 'tipodespesas';

export default function Cadastro() {
  const [table, setTable] = useState([]);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme();

  useEffect(() => {
    async function getData() {
      try {
        setIsLoading(true);
        const response = await axios.get(`/${tableDatas}`);
        setTable(response.data);
      } catch (err) {
        const status = get(err, 'response.status', 0);
        const errors = get(err, 'response.data.errors', []);

        if (status === 400) errors.map((error) => toast.error(error));
        navigate(`/home`);
      } finally {
        setIsLoading(false);
      }
    }

    getData();
  }, [navigate]);

  const handleDeleteAsk = (id) => {
    setDeleteConfirmId(id);
  };

  const handleDelete = async (e, id, index) => {
    e.persist();

    try {
      setIsLoading(true);
      await axios.delete(`/${tableDatas}/${id}`);
      const newTable = [...table];
      newTable.splice(index, 1);
      setTable(newTable);
      setIsLoading(false);
      toast.success('Registro excluido com sucesso.');
    } catch (err) {
      const status = get(err, 'response.status', 0);
      if (status === 401) {
        toast.error('Você precisa fazer login');
      } else if (status === 400) {
        toast.error(
          `Registro não pode ser excluído: Relacionamento entre tabelas.`
        );
      } else {
        toast.error(`Ocorreu um erro ao excluir registro.`);
      }
      setIsLoading(false);
    }
    // getData();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: 'id', // access nested data with dot notation
        header: 'ID',
        size: 80,
        hidden: true,
      },
      {
        accessorKey: 'nome',
        header: 'Tipo de Despesa',
        size: 80,
      },
      {
        accessorKey: 'descricao',
        header: 'Descrição',
        size: 80,
      },
      {
        header: 'Flag',
        accessorFn: (row) => {
          const flags = [
            row.flag_motorista && 'Motorista',
            row.flag_combustivel && 'Combustível',
            row.flag_veiculo && 'Veículo',
            row.flag_adm && 'Administrativo',
            row.flag_arla && 'Arla',
            row.flag_descarga && 'Descarga',
            row.flag_outros && 'Outros',
          ].filter(Boolean);

          return flags.length > 0 ? flags.join(' | ') : 'N/A';
        },
        size: 80,
      },
    ],
    []
  );

  return (
    <ContainerGrid>
      <Loading isLoading={isLoading} />
      <Title>{`${textData}`}</Title>

      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          onClick={() => navigate(`/${tableRoute}`)}
        >
          <AddIcon size={24} />
        </Button>
        <Button
          type="button"
          color="secondary"
          variant="contained"
          style={{ marginLeft: '5px' }}
          onClick={() => navigate(`/home`)}
        >
          Fechar
        </Button>
      </Box>
      <ThemeProvider theme={createTheme(theme, ptBR)}>
        <MaterialReactTable
          columns={columns}
          data={table}
          // enableColumnFilterModes
          enableColumnOrdering
          // enableEditing
          // enablePinning
          enableRowActions
          // enableRowSelection
          // enableSelectAll={false}
          initialState={{
            density: 'compact',
            showColumnFilters: false,
            showGlobalFilter: false,
            columnVisibility: { id: false },
          }}
          localization={MRT_Localization_PT_BR}
          renderRowActions={({ row }) => (
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <Tooltip arrow placement="left" title="Editar">
                <Link to={`/${tableRoute}/${row.getValue('id')}/edit`}>
                  <FaEdit size={16} />
                </Link>
              </Tooltip>
              <Tooltip arrow placement="right" title="Excluir">
                <div>
                  {deleteConfirmId === row.getValue('id') ? (
                    <FaExclamation
                      size={16}
                      color={colors.errorColor}
                      cursor="pointer"
                      onClick={(e) =>
                        handleDelete(e, row.getValue('id'), row.id)
                      }
                    />
                  ) : (
                    <FaWindowClose
                      size={16}
                      color={colors.primaryColor}
                      cursor="pointer"
                      onClick={() => handleDeleteAsk(row.getValue('id'))}
                    />
                  )}
                </div>
              </Tooltip>
              <Tooltip arrow placement="left" title="Detalhes">
                <Link to={`/tipodespesadetalhes/${row.getValue('id')}`}>
                  <FaClipboardList size={16} />
                </Link>
              </Tooltip>
            </Box>
          )}
        />
      </ThemeProvider>
    </ContainerGrid>
  );
}
